(function () {

  'use strict';

  angular.module('eclipseApp.core')

    .factory('promptService', ['$timeout', '$window', 'uteModal', '$rootScope', '$cookies', 'userService', '$http', 'uteEndpoint', 'util', 'janrainService', 'uteLocale', function ($timeout, $window, uteModal, $rootScope, $cookies, userService, $http, uteEndpoint, util, janrainService, uteLocale) {

      var service = {};

      service.checkNextAction = function () {
        if (util.getParameterByName('rs') === 'rps') {
          userService.promptResetPassword();
        } else if (util.getParameterByName('rs') === 'verifyEmail') {
          userService.promptAutoRegComplete();
        }
      };

      /**
       * @description opens up first time user province selection modal
       */
      service.promptUser = function (detectedProvince) {
        if (!$window.getUserPrefCookie('firstTimeUser')) {
          service.checkNextAction();
          return;
        }

        detectedProvince = detectedProvince || uteLocale.actualProvince;
        var selectedProvince = detectedProvince;

        uteModal.open({
          templateUrl: 'views/templates/modal/province-selection-modal.html',
          controller: ['$scope', '$modalInstance', function ($scope, $modalInstance) {
            // set user province as default
            $scope.selectedProvince = detectedProvince.toLowerCase();
            $scope.ok = function () {
              selectedProvince = $scope.selectedProvince.toUpperCase();
              $modalInstance.close();
            };
            $scope.cancel = function () {
              $modalInstance.dismiss('cancel');
            };
          }],
          size: 'lg',
          backdrop: true
        }).result.then(
          // save firstTimeUser cookie until the modal is closed
          // just in case the browser is reloaded after this modal is displayed
          function () {
            updateFirstTimeUserAndProvinceCookies(selectedProvince);
          },
          function () {
            updateFirstTimeUserAndProvinceCookies(selectedProvince);
          }
        );
      };

      /**
       * @description setup firstTimeUser cookie to false, and setup the province if it's changed
       */
      var updateFirstTimeUserAndProvinceCookies = function (prov) {

        if (uteLocale.province.toLowerCase() !== prov.toLowerCase()) {

          $window.setUserPrefCookies([
            {key: 'firstTimeUser', value: false},
            {key: 'province', value: prov}
          ]);

        } else {

          $window.setUserPrefCookies([
            {key: 'firstTimeUser', value: false}
          ]);

          service.checkNextAction();

        }

        $window.setCookie('province', prov, {
          expires: 30,
          path: '/'
        }, false);

      };


      // prompt user to select province; select detected (via API) as default
      // service.promptAutoRegComplete = function () {
      //   userService.promptAutoRegComplete();
      // };

      // prompt user to select province; select detected (via API) as default
      // service.promptPasswordReset = function () {
      //   userService.promptResetPassword();
      // };

      // prompt user to select province; select detected (via API) as default
      service.promptUserProvince = function (detectedProvince) {

        var modalInstance = $modal.open({
          templateUrl: 'views/templates/modal/province-selection-modal.html',
          controller: ['$scope', '$modalInstance', function ($scope, $modalInstance) {
            $rootScope.userPref.getUserPref = false;
            // set user province as default
            $scope.selectedProvince = detectedProvince;
            $scope.ok = function () {
              uteLocale.province = $scope.selectedProvince; // save the selected province in uteLocale
              $modalInstance.close($scope.selectedProvince);
            };
            $scope.cancel = function () {
              // no province selected, use the actual one
              $modalInstance.dismiss('cancel');
            };
          }],
          size: 'lg',
          backdrop: true
        });

        // dismissing the modal via ok/cancel
        modalInstance.result.then(function (selectedProvince) {
            // save on 'ok'
            if (uteLocale.province != selectedProvince) {
              uteLocale.province = selectedProvince;
            }
            service.checkNextAction();
          },
          function () {
            service.checkNextAction();
          }
        );
      };
      return service;
    }]);

})();
